import React, { FC, useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { Tags, Icon } from '@cps'
import { favoMobx, doProductMobx } from 'mobx/mall'
import { format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { handleShareForWxa } from '@common/utils/share'
import { DetailTop } from '..'
import defaultProduct from 'assets/images/default-longMallProduct.png'
import { ReturnServiceModal } from '../../modal'
import repositoryMobx from '@mobx/mall/repository.mobx'
import './index.scss'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  no?: string;
  imgUrl: string;
  picWidth: number;
  picHeight: number;
  name: string;
  intro?: string;
  allergys: IAllergy[];
  tags: ITag[];
  statSaleCnt?: number;
  totalPrice?: number;
  totalActualPrice?: number;
  cnt: number;
  showDefaultPic?: boolean;
  pics?: string;
}

const DetailInfo: FC<IProps> = ({ no, imgUrl, pics, totalPrice, tags, statSaleCnt, totalActualPrice, name, intro }) => {
  const [isFavoite, setIsFavoite] = useState(false)
  const imgStyle = useMemo(() => {
    const imgArr = pics ? JSON.parse(pics) : []
    const width = imgArr.length ? imgArr[0].w || 1 : 1
    const height = imgArr.length ? imgArr[0].h || 1 : 1
    return {
      width: window.innerWidth,
      height: window.innerWidth * height / width
    }
  }, [pics])

  const handReturnService = () => {
    modalLayer(ReturnServiceModal, null, 'ReturnServiceModal').catch(() => { })
  }

  const handleShare = () => {
    handleShareForWxa({ mode: 'card', scene: 'mallProduct', router: `/mproduct/${no}`, title: name, imageUrl: imgUrl, shareImageInfo: { price: totalActualPrice || totalPrice } })
  }
  const handleFavorite = () => {
    if (isFavoite) {
      favoMobx.delete(doProductMobx.doProduct)
    } else {
      favoMobx.add(doProductMobx.doProduct)
    }
  }
  useEffect(() => {
    let data = favoMobx.productNoToIdMap[doProductMobx.doProduct.no]
    setIsFavoite(!!data)
  }, [favoMobx.productList])

  return (
    <>
      <DetailTop imgUrl={imgUrl || defaultProduct} pics={pics} imgStyle={imgStyle} />
      <div className='product-detail-container'>
        <div className='product-detail-wrapper'>
          <div className='product-detail-name'>
            <h3 className='detail-name'>{name}</h3>
            <div className='btn-share'>
              <Icon name={isFavoite ? 'likefill' : 'like1'} onClick={handleFavorite} />
              <Icon name='fenxiang' onClick={handleShare} />
            </div>
          </div>
          {
            !!statSaleCnt && <p className='detail-month-sale-info'>{i18n.t('menu.monthSaleCnt', { cnt: statSaleCnt })}</p>
          }
          <Tags datas={[...(tags || [])]} />
          <div className='price-wrap'>
            <div dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(totalActualPrice) }}></div>
            {totalPrice !== totalActualPrice ? <span dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(totalPrice) }}></span> : null}
          </div>
          {/* <div className='content-wrapper member'>
            <Icon name='piaoju' />
            <span>会员首单88折</span>
          </div> */}
          {intro && intro !== '<p></p>' ? (
            <div className='detail-introduce-wrapper'>
              <div className='detail-introduce-title'>{i18n.t('mall.productDetail')}</div>
              <div className='detail-introduce' dangerouslySetInnerHTML={{ __html: intro }}></div>
            </div>
          ) : null}
          {
            repositoryMobx.info.returnIntro && (
              <div className='content-wrapper return' onClick={handReturnService}>
                <Icon name='tuihuoshuoming' />
                <span>{i18n.t('mall.understand')} {i18n.t('mall.returnService')}</span>
              </div>
            )
          }
        </div>
      </div>
    </>
  )
}

export default observer(DetailInfo)
